import React, { useEffect, Fragment, useState  } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Nav, Navbar, Row, Col } from 'react-bootstrap';
import { navbarBreakPoint, topNavbarBreakpoint } from 'config';
import Flex from 'components/common/Flex';
import Logo from '../../../features-csvc/q_logo/Logo';
import NavbarVerticalMenu from './NavbarVerticalMenu';
import ToggleButton from './ToggleButton';
// import routes from 'routes/siteMaps';
// import routesPartner from 'routesPartner/siteMaps';
// import routesMaster from 'routesMaster/siteMaps';
// import routes from 'routesORIGINALE/siteMaps';
import { capitalize } from 'helpers/utils';
import NavbarTopDropDownMenus from 'components/navbar/top/NavbarTopDropDownMenus';
import bgNavbar from 'assets/img/generic/bg-navbar.png';

import { useAppContext } from 'providers/AppProvider';
import { useSelector } from 'react-redux'

import {pannelloDiControllo} from './menuGroup_pannelloDiControllo'
import {welcome} from './menuGroup_welcome'
//import {compilazioneDatigeneraliQuestionario} from './menuGroup_compilazioneDatigeneraliQuestionario'
import {avvio} from './menuGroup_avvio'

//import {compilazioneAmbitiSelezionati} from './menuGroup_compilazioneAmbitiSelezionati'
import {funzioneSelezionaAmbiti} from './menuGroup_funzioneSelezionaAmbiti'

import {output} from './menuGroup_output'
import {metodologia} from './menuGroup_metodologia'


const NavbarVertical = () => {
  const {
    config: {
      navbarPosition,
      navbarStyle,
      isNavbarVerticalCollapsed,
      showBurgerMenu
    }
  } = useAppContext();

  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  const csvcRole = useSelector((state) => state.utenteCorrente.csvcRole);

//  const flag_pannelloDiControllo = useSelector((state) => state.siteMaps.pannelloDiControllo);
//  const flag_compilazioneDatigeneraliQuestionario = useSelector((state) => state.siteMaps.compilazioneDatigeneraliQuestionario);
//  const flag_compilazioneAmbitiSelezionati = useSelector((state) => state.siteMaps.compilazioneAmbitiSelezionati);
//  const flag_output = useSelector((state) => state.siteMaps.output);
//  const flag_metodologia = useSelector((state) => state.siteMaps.metodologia);

  useEffect(() => {
    if (isNavbarVerticalCollapsed) {
      HTMLClassList.add('navbar-vertical-collapsed');
    } else {
      HTMLClassList.remove('navbar-vertical-collapsed');
    }
    return () => {
      HTMLClassList.remove('navbar-vertical-collapsed-hover');
    };
  }, [isNavbarVerticalCollapsed, HTMLClassList]);

  //Control mouseEnter event
  let time = null;
  const handleMouseEnter = () => {
    if (isNavbarVerticalCollapsed) {
      time = setTimeout(() => {
        HTMLClassList.add('navbar-vertical-collapsed-hover');
      }, 100);
    }
  };
  const handleMouseLeave = () => {
    clearTimeout(time);
    HTMLClassList.remove('navbar-vertical-collapsed-hover');
  };

  const NavbarLabel = ({ label }) => (
    <Nav.Item as="li">
      <Row className="mt-3 mb-2 navbar-vertical-label-wrapper">
        <Col xs="auto" className="navbar-vertical-label navbar-vertical-label">
          {label}
        </Col>
        <Col className="ps-0">
          <hr className="mb-0 navbar-vertical-divider"></hr>
        </Col>
      </Row>
    </Nav.Item>
  );


    // INIZIO 2025-03-16 upgrade di Antonio per auto-configurare il menu
    // const dispatch = useDispatch();
    const menuProfile = useSelector((state) => state.menuConfig.menuProfile);
    const ambiti = useSelector((state) => state.questCorrente.ambiti);

    const [myNewRoutesGenerator, setMyNewRoutesGenerator] = useState([]);
  
    // Algoritmo per rigenerare il menù
    const regenerateMenu = () => {
      // Logica per rigenerare il menù
      let myNewRoutes = []
      switch (menuProfile){
        case 'master':
          myNewRoutes = []
          myNewRoutes.push(pannelloDiControllo)   
          break
        case 'partnerSoloPannello':
          myNewRoutes = []
          myNewRoutes.push(pannelloDiControllo)   
          break
        case 'partnerPannelloEtQuestionario':
          myNewRoutes = []
          myNewRoutes.push(pannelloDiControllo)   
          myNewRoutes.push(welcome)
          myNewRoutes.push(avvio)
          myNewRoutes.push(funzioneSelezionaAmbiti(ambiti))
          myNewRoutes.push(output)
          myNewRoutes.push(metodologia)
          break
        case 'azienda':
        default:
          myNewRoutes = []
          myNewRoutes.push(welcome)
          myNewRoutes.push(avvio)
          myNewRoutes.push(funzioneSelezionaAmbiti())
          myNewRoutes.push(output)
          myNewRoutes.push(metodologia)
          break
      }
      setMyNewRoutesGenerator(myNewRoutes);
    };
  
    useEffect(() => {
      // Esegui l'algoritmo quando menuProfile cambia
      console.log ('**** Est cambiato menuProfile ****')
      regenerateMenu();
    }, [menuProfile, ambiti]);
    // INIZIO 2025-03-16 upgrade di Antonio per auto-configurare il menu
  
  // =========================================================================
  
  let myRoutes = null
  switch (csvcRole){
    case 'master':
    case 'partner':
    case 'azienda':
    default:
      myRoutes = myNewRoutesGenerator.map(route => (
        <Fragment key={route.label}>
          {!route.labelDisable && (
            <NavbarLabel label={capitalize(route.label)} />
          )}
          <NavbarVerticalMenu routes={route.children} />
        </Fragment>
      ))
      break;
  }

  return (
    <Navbar
      expand={navbarBreakPoint}
      className={classNames('navbar-vertical', {
        [`navbar-${navbarStyle}`]: navbarStyle !== 'transparent'
      })}
      variant="light"
    >
      <Flex alignItems="center">
        <ToggleButton />
        <Logo at="navbar-vertical" textClass="text-primary" width={40} />
      </Flex>
      <Navbar.Collapse
        in={showBurgerMenu}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{
          backgroundImage:
            navbarStyle === 'vibrant'
              ? `linear-gradient(-45deg, rgba(0, 160, 255, 0.86), #0048a2),url(${bgNavbar})`
              : 'none'
        }}
      >
        <div className="navbar-vertical-content scrollbar">
          <Nav className="flex-column" as="ul">
            { myRoutes }
          </Nav>
          <>
            {navbarPosition === 'combo' && (
              <div className={`d-${topNavbarBreakpoint}-none`}>
                <div className="navbar-vertical-divider">
                  <hr className="navbar-vertical-hr my-2" />
                </div>
                <Nav navbar>
                  <NavbarTopDropDownMenus />
                </Nav>
              </div>
            )}
          </>
        </div>
      </Navbar.Collapse>
    </Navbar>
  );
};

NavbarVertical.propTypes = {
  label: PropTypes.string
};

export default NavbarVertical;
